import React from 'react';

export default function TerminosPage() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px', fontFamily: 'Arial, sans-serif', color: '#1f2937', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8, color: '#0f172a' }}>Términos y Condiciones</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 32 }}>Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>1. Aceptación de los términos</h2>
        <p>
          Al utilizar los servicios de <strong>Activo Contadores</strong> y/o realizar pagos a través de nuestra plataforma,
          usted acepta los presentes Términos y Condiciones. Si no está de acuerdo, le pedimos que no utilice nuestros servicios.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>2. Descripción del servicio</h2>
        <p>
          Activo Contadores presta servicios de contabilidad, declaraciones fiscales, trámites ante el SAT e IMSS,
          y asesoría contable-fiscal a personas físicas y morales en México. Los cobros realizados a través
          de esta plataforma corresponden a honorarios por dichos servicios.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>3. Proceso de pago</h2>
        <p>
          Los pagos son procesados de forma segura a través de <strong>Openpay</strong>, empresa certificada bajo el estándar
          PCI DSS Nivel 1. Aceptamos tarjetas de crédito y débito Visa, Mastercard y American Express.
        </p>
        <ul style={{ paddingLeft: 20 }}>
          <li>Los precios están expresados en Pesos Mexicanos (MXN) e incluyen IVA cuando aplica.</li>
          <li>El link de pago tiene una vigencia de 72 horas a partir de su generación.</li>
          <li>Al completar el pago recibirá una confirmación en pantalla.</li>
          <li>Los datos de su tarjeta son procesados directamente por Openpay y nunca son almacenados en nuestros servidores.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>4. Política de reembolsos</h2>
        <p>
          Dado que ofrecemos servicios profesionales, los pagos realizados no son reembolsables una vez que
          el servicio ha sido prestado. En caso de inconformidad o error en el cobro, contáctenos dentro
          de los 5 días hábiles siguientes al pago en <strong>agustin@activocontadores.com</strong> para revisar su caso.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>5. Responsabilidades del cliente</h2>
        <p>El cliente se compromete a:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li>Proporcionar información veraz y actualizada para la prestación de los servicios.</li>
          <li>Entregar documentación e información fiscal en los tiempos acordados.</li>
          <li>Realizar los pagos en los plazos establecidos.</li>
          <li>Notificar cualquier cambio en su situación fiscal o de negocio que pudiera afectar los servicios contratados.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>6. Limitación de responsabilidad</h2>
        <p>
          Activo Contadores no se hace responsable por errores derivados de información incompleta o incorrecta
          proporcionada por el cliente, ni por sanciones del SAT o IMSS originadas por incumplimiento del cliente
          en la entrega de documentación. Nuestra responsabilidad se limita al valor del servicio contratado.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>7. Confidencialidad</h2>
        <p>
          Toda la información fiscal y contable que el cliente nos proporcione será tratada con estricta
          confidencialidad y no será divulgada a terceros, salvo requerimiento de autoridades competentes
          o consentimiento expreso del cliente.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>8. Ley aplicable</h2>
        <p>
          Los presentes términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier
          controversia, las partes se someten a la jurisdicción de los tribunales competentes en México.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>9. Contacto</h2>
        <p>Para cualquier duda sobre estos términos, contáctenos:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li><strong>Email:</strong> agustin@activocontadores.com</li>
          <li><strong>Teléfono:</strong> 664 494 0143</li>
          <li><strong>Domicilio:</strong> Calle Ryerson 106, Zona Centro, Ensenada, Baja California, C.P. 22800</li>
        </ul>
      </section>

      <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 20, marginTop: 32, color: '#6b7280', fontSize: 13 }}>
        <p>Activo Contadores · Calle Ryerson 106, Zona Centro, Ensenada, B.C. C.P. 22800 · Tel: 664 494 0143 · <a href="mailto:agustin@activocontadores.com" style={{ color: '#3280ed' }}>agustin@activocontadores.com</a></p>
      </div>
    </div>
  );
}
